// extracted by mini-css-extract-plugin
export default {"text":"order-history_text__s7COa","scroll":"order-history_scroll__UCdTL"};